import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect, MultiSelect } from 'vue-search-select';
import CreateTariffCard from './../createtariffcard';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import MasterService from './../../../services/masterdata.service';
import CONSTANT from './../../../../shared/constants/constant';
import Util from './../../../../shared/util/util';

export default {
	name: 'Tarrif-Card-Listing',
	components: {
		VueElementLoading,
		Pagination,
		BasicSelect,
		CreateTariffCard,
		VueElementLoading,
		CustomExpandableTable
	},
	props: [],
	data: function() {
		return {
			tariffcardName: '',
			tariffcardNameSearch: '',
			type: 'TARRIF_CARD_MASTER',
			showlist: true,
			isLoading: false,
			tableColumn: ['Tariff Card Name', 'Route Mode', 'Rate Basis','Tariff Card Rate Type', '#of Slab Breaks','Created By','Created Date','Last Modified By','Last Modified Date','Status','Action'],
			innerTableColumn: ['name', 'id', 'dummylable', 'name1', 'id1', 'dummylable1'],
			tableArr: [],
			tableItems: [],
			currentPage: 1,
			totalPage: 0,
			totalCount: 0,
			offset: 0,
			pageLimit: CONSTANT.PER_PAGE_DATA,
			selectedTariffCardObj: '',
			status:"",
			statusSearch:"",
			statuslist:[{
        value : "1",
        text : 'Active'
      },{
        value : "0",
        text : 'Inactive'
      }],
      statusitem:{value:'',text:''},
		}
	},
	computed: {

	},
	mounted() {
		this.getTariffCardListing();
	},
	methods: {
		selectedStatus(statusitem){
      this.statusitem = statusitem;
      this.status = this.statusitem.value;
    },
		showCreateTariffCard() {
			this.selectedTariffCardObj = [];
			this.showlist = false;
		},
		async activeAction(data){
			try {
				this.isLoading = true;
				var item = this.tableArr.find(item => item.id === data.id);
				var isactivestatus = item.status == 0 ? 1 : 0
				let inputPayload = {
					"id": data.id,
					"type": this.type,
					"status": isactivestatus
				}
				let result = await MasterService.changeStatus(inputPayload)
				if(result.data.code == 200){
					if(result.data.data[0].status == 0){
					this.$alert("Tarrif Card Activated Successfully!!", item.tariffcardname, "success");
				}else{
					this.$alert("Tarrif Card Inactivated Successfully!!", item.tariffcardname, "success");
				 }
					this.getTariffCardListing();
					this.isLoading = false;
				}else{
					this.$alert(result.data.message,"", "error");
					this.isLoading = false;
				}
			} catch(err){
				console.log(err);
			}
		},
		callParent() {
			this.showlist = true;
			this.selectedTariffCardObj = null;
			this.currentPage = 1;
			this.offset = 0;
			this.getTariffCardListing();
		},
		onPageChange(page) {
			this.currentPage = page;
			this.offset = (page - 1) *this.pageLimit
			this.getTariffCardListing();
		},
		getCustomTableEvent(event) {
			if(event.actionType=="active"){
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
        this.activeAction(event);
       }).catch((err)=>{
         console.log(err)
       });
     }else if(event.actionType=="inactive"){
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
        this.activeAction(event);
       }).catch((err)=>{
         console.log(err)
       })
      }
			if (event.actionType == "edit") {
				let selectedTariffCardObj = this.tableArr.filter(function(Items) {
					return Items.id == event.id;
				});
				this.selectedTariffCardObj = selectedTariffCardObj[0];
				this.showlist = false;
			}
		},
		searchTariffCard() {
			this.currentPage = 1;
			this.offset = 0;
			this.tariffcardNameSearch = this.tariffcardName;
			this.statusSearch = this.status;
			this.getTariffCardListing();
		},
		resetTariffCard() {
			this.currentPage = 1;
			this.tariffcardName = "";
			this.tariffcardNameSearch = "";
			this.status = "";
			this.statusSearch = "";
			this.statusitem = {};
			this.getTariffCardListing();
		},
		async getTariffCardListing() {
			try {
				this.isLoading = true;
				let inputPayload = {
					"offset": this.offset,
					"limit": this.pageLimit
				}
				if(this.tariffcardNameSearch!=""){
					inputPayload.tariffcardname = this.tariffcardNameSearch;
				}
				if(this.statusSearch!=""){
				  inputPayload.status = this.statusSearch;
				}

				let allResolved = await Promise.all([MasterService.getTariffCardListing(inputPayload)])
				let result = allResolved[0];
				this.isLoading = false;
				this.totalCount = result.data.data.count;
				this.tableArr = result.data.data.rows;
				this.tableItems = result.data.data.rows.map((el) => {
				var cardRateType = '';
					if (el.tariffcardtype == CONSTANT.ACCESSORIAL_RATE_TYPE.FLAT) {
						cardRateType = "Flat";
					} else {
						cardRateType = "Slab";
					}
					return {
						'id': el.id,
						'Tariff Card Name': el.tariffcardname,
						'Route Mode': el.routemode,
						'Rate Basis': el.ratebasis==1?'Weight (kg)':'Quantity (Number of boxes)',
						'Tariff Card Rate Type': cardRateType,
						'#of Slab Breaks':el.slabbreakcount,
						'Created By':el.createdby,
						'Created Date':Util.displayDateTimeFormat(el.createddate),
						'Last Modified By':el.lastmodifiedby,
					  'Last Modified Date':Util.displayDateTimeFormat(el.lastmodifieddate),
						'Status': el.status,
						'Action': 'Edit'
					}
				});
				if (this.totalCount < this.pageLimit) {
					this.totalPage = 1;
				} else {
					this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
				}
			} catch (err) {
				this.isLoading = false;
				console.log(err);
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/tariffcard/tariffcardlisting/tariffcardlisting.component.js